import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material'
import React, { MouseEvent, useState } from 'react'

export const DeleteOptionsMenu = ({
  deleted,
  onDelete,
  onUndelete,
  entityName
}: {
  deleted: boolean
  onDelete: () => void
  onUndelete: () => void
  entityName: string
}) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null)
  const menuOpen = Boolean(menuAnchor)
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const onClose = () => setDialogOpen(false)

  const handleDeleteClick = () => {
    setDialogOpen(true)
    setMenuAnchor(null)
  }

  return (
    <>
      <Dialog open={dialogOpen} onClose={onClose}>
        <DialogTitle>
          Confirm {deleted ? 'Unarchive' : 'Archive'} {entityName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {deleted ? 'unarchive' : 'archive'} this{' '}
            {entityName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={() => {
              deleted ? onUndelete() : onDelete()
              onClose()
            }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={(event: MouseEvent<HTMLElement>) => {
          setMenuAnchor(event.currentTarget)
        }}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        open={menuOpen}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}>
        <MenuItem onClick={handleDeleteClick}>
          {deleted ? 'Unarchive' : 'Archive'}
        </MenuItem>
      </Menu>
    </>
  )
}
